import { render, staticRenderFns } from "./UISelectProfileModal.vue?vue&type=template&id=6f06e986"
import script from "./UISelectProfileModal.vue?vue&type=script&lang=js"
export * from "./UISelectProfileModal.vue?vue&type=script&lang=js"
import style0 from "./UISelectProfileModal.vue?vue&type=style&index=0&id=6f06e986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
